import { Box, Flex, Icon, IconButton, Text } from '@/ui';

type Props = {
  onClose: () => void;
};

export const ExportSidebarHeader = ({ onClose }: Props) => (
  <Box flexShrink={0} pb={4} pt={5} px={5}>
    <Flex align="flex-start" gap={2} justify="space-between">
      <Text
        color="ink.strong"
        fontFamily="display"
        fontSize="ah-display"
        lineHeight={1.15}
      >
        Send to calendar
      </Text>
      <IconButton
        aria-label="Close send to calendar panel"
        icon={<Icon icon="X" />}
        mt={-1}
        size="sm"
        variant="ghost"
        onClick={onClose}
      />
    </Flex>
  </Box>
);
